export enum LocationType {
  DESTINATION = "destination",
  ORIGIN = "origin",
}
